import { lazy } from 'react';
import Loadable from 'components/Loadable';
import PublicRoute from 'routes/PublicRoute';

const LoginPage = Loadable(lazy(() => import('./components/login-page/LoginPage')));
const ForgotPasswordPage = Loadable(lazy(() => import('./components/forgot-password-page/ForgotPasswordPage')));
const VerifyEmailPage = Loadable(lazy(() => import('./components/verify-email-page/VerifyEmailPage')));

export const authRoutes = {
  path: '/',
  children: [
    {
      path: '/login',
      element: <PublicRoute><LoginPage /></PublicRoute>
    },
    {
      path: '/forgot-password',
      element: <PublicRoute><ForgotPasswordPage /></PublicRoute>
    },
    {
      path: '/verify-email',
      element: <PublicRoute><VerifyEmailPage /></PublicRoute>
    }
  ]
};

export default authRoutes;
